import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from '@cld/theme-helper';

const t = theme({ basePath: 'components.popover.paper' });

export const Paper = styled.div`
  background: ${t`background`};
  box-shadow: ${t`shadow`};

  ${(props) =>
    props.rounded &&
    css`
      border-radius: ${t`borderRadius`};
    `};
  ${(props) =>
    props.padded &&
    css`
      padding: ${t`padding`};
    `};
`;

Paper.propTypes = {
  rounded: PropTypes.bool,
  padded: PropTypes.bool,
};
